var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "new-item-field" }, [
        _c(
          "div",
          { staticClass: "field-input-group" },
          [
            _c("sc-field", {
              staticClass: "field-group",
              attrs: { label: this.fieldSchema.key_name }
            }),
            _vm._v(" "),
            _c("sc-input", {
              staticClass: "input-group",
              attrs: {
                placeholder: this.fieldSchema.key_name,
                disabled: _vm.editMode
              },
              model: {
                value: _vm.fieldKey,
                callback: function($$v) {
                  _vm.fieldKey = $$v
                },
                expression: "fieldKey"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field-input-group" },
          [
            _c("sc-field", {
              staticClass: "field-group",
              attrs: { label: this.fieldSchema.value_name }
            }),
            _vm._v(" "),
            _c("sc-input", {
              staticClass: "input-group",
              attrs: {
                placeholder: this.fieldSchema.value_name,
                disabled: _vm.editMode
              },
              model: {
                value: _vm.fieldValue,
                callback: function($$v) {
                  _vm.fieldValue = $$v
                },
                expression: "fieldValue"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-field-button" },
          [
            _c(
              "sc-tooltip",
              { attrs: { label: "Adicionar", position: "is-bottom" } },
              [
                _c(
                  "sc-button",
                  {
                    attrs: {
                      theme: "primary",
                      "icon-left": "save",
                      disabled: _vm.editMode
                    },
                    on: {
                      click: function() {
                        return _vm.addField()
                      }
                    }
                  },
                  [_vm._v("\n          Adicionar\n        ")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      this.data.length > 0
        ? _c("sc-table", {
            attrs: { data: this.data, columns: this.columns },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "sc-table-column",
                      { attrs: { field: "id", visible: true } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(props.row.id) + "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      [
                        props.row.id == _vm.selectedItemIdToEdit && _vm.editMode
                          ? _c("sc-input", {
                              model: {
                                value: props.row.key,
                                callback: function($$v) {
                                  _vm.$set(props.row, "key", $$v)
                                },
                                expression: "props.row.key"
                              }
                            })
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(props.row.key) +
                                  "\n          "
                              )
                            ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      [
                        props.row.id == _vm.selectedItemIdToEdit && _vm.editMode
                          ? _c("sc-input", {
                              model: {
                                value: props.row.value,
                                callback: function($$v) {
                                  _vm.$set(props.row, "value", $$v)
                                },
                                expression: "props.row.value"
                              }
                            })
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(props.row.value) +
                                  "\n          "
                              )
                            ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-table-column",
                      [
                        _c(
                          "sc-tooltip",
                          { attrs: { label: "Editar", position: "is-bottom" } },
                          [
                            props.row.id != _vm.selectedItemIdToEdit
                              ? _c("sc-button", {
                                  attrs: { theme: "primary", icon: "pen" },
                                  on: {
                                    click: function() {
                                      return _vm.handleEdit(props.row)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-tooltip",
                          { attrs: { label: "Salvar", position: "is-bottom" } },
                          [
                            props.row.id == _vm.selectedItemIdToEdit &&
                            _vm.editMode
                              ? _c("sc-button", {
                                  attrs: { theme: "primary", icon: "save" },
                                  on: {
                                    click: function() {
                                      return _vm.saveEdit(props.row)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-tooltip",
                          {
                            attrs: {
                              label: "Deletar",
                              position: "is-bottom",
                              type: "is-danger"
                            }
                          },
                          [
                            _c("sc-button", {
                              attrs: { theme: "danger", icon: "trash" },
                              on: {
                                click: function() {
                                  return _vm.deleteRow(props.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78d99371", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d99371","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/modal/components/MapField.vue
// module id = null
// module chunks = 